// extracted by mini-css-extract-plugin
export default {"container":"_2a_IZ","titleAndContent":"_1mXyX","title":"_3oXog","subtitle":"_1jRiV","subtitleText":"eQauP","content":"IcTis","extraFooterSpacing":"FwZcT"};